"use strict";
(()=>{
  let e, t, r, d, o, i, c, n, s, l, a;

  /* ─── Pausa medios activos ─── */
  function pauseActiveMedia() {
    if (!t) return;
    t.querySelectorAll("video").forEach(v => v.pause());
    t.querySelectorAll(".js-youtube").forEach(v => {
      v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    });
    t.querySelectorAll(".js-vimeo").forEach(v => {
      v.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    t.querySelectorAll("product-model").forEach(v => {
      v.modelViewerUI && v.modelViewerUI.pause();
    });
  }

  /* ─── Callback Glide al cambiar slide ─── */
  function u(e, r) {
    h(r.index);
    v(r.index);
    pauseActiveMedia();
    const slide = r._c.Html.slides[r.index];
    if ("image" !== slide.dataset.mediaType && !slide.dataset.mediaReady) {
      const img  = slide.querySelector(".js-product-media-primary-img");
      const tmpl = slide.querySelector(".js-product-media-template");
      const vid  = tmpl.content.querySelector(".js-product-media-video").cloneNode(true);
      img.replaceWith(vid);
      tmpl.remove();
      slide.dataset.mediaReady = true;
    }
  }

  /* ─── Click en imagen principal → zoom original del tema ─── */
  function m(ev) {
    const img = ev.target.closest(".js-product-media-primary-img");
    if (!img || !t || !t.contains(img) || img.dataset.mediaType !== "image") return;
    if (!n || !s) return;
    s.classList.add("gr-hidden");
    document.body.style.overflow = "hidden";
    n.classList.remove("gr-hidden");
    n.classList.add("gr-product-media-magnify--loading");
    s.onload = () => {
      s.classList.remove("gr-hidden");
      n.classList.remove("gr-product-media-magnify--loading");
    };
    s.loading = "eager";
    s.src = img.src;
    if (img.srcset) s.srcset = img.srcset;
  }

  function p() { h("prev"); }
  function f() { h("next"); }

  /* ─── Activar miniatura ─── */
  function activateThumb(idx) {
    idx = Number(idx);
    e.go("=" + idx);
    scrollToThumb(idx);
    v(idx);
  }

  /* ─── Scroll de la tira de miniaturas ─── */
  function y(val, step) { return Math.round(val / step) * step; }

  function scrollToThumb(idx) {
    if (!o || !r || r.length === 0) return;

    /* Leer dimensiones reales del DOM sin pasar por los getters parcheados */
    const track = o;
    const isMobile = window.innerWidth < 750;

    if (typeof idx === "number" && !isNaN(idx) && r[idx]) {
      const thumb = r[idx];
      const first = r[0];
      if (isMobile) {
        const left = thumb.offsetLeft - first.offsetLeft;
        track.scrollTo({ left: left, top: 0, behavior: "smooth" });
      } else {
        const top = thumb.offsetTop - first.offsetTop;
        track.scrollTo({ left: 0, top: top, behavior: "smooth" });
      }
      return;
    }

    /* prev / next */
    const step = isMobile
      ? track.scrollWidth / r.length
      : track.scrollHeight / r.length;

    let pos;
    if (idx === "prev") {
      pos = isMobile
        ? (track.scrollLeft === 0 ? track.scrollWidth - track.clientWidth : y(track.scrollLeft - step, step))
        : (track.scrollTop  === 0 ? track.scrollHeight - track.clientHeight : y(track.scrollTop - step, step));
    } else {
      pos = isMobile
        ? (track.scrollLeft >= track.scrollWidth  - track.clientWidth  ? 0 : y(track.scrollLeft + step, step))
        : (track.scrollTop  >= track.scrollHeight - track.clientHeight ? 0 : y(track.scrollTop  + step, step));
    }

    if (isMobile) {
      track.scrollTo({ left: pos, top: 0, behavior: "smooth" });
    } else {
      track.scrollTo({ left: 0, top: pos, behavior: "smooth" });
    }
  }

  /* Alias público que usa product-media-new.js */
  function h(idx) { scrollToThumb(idx); }

  /* ─── Resaltar miniatura activa ─── */
  function v(idx) {
    if (!d || !d[Number(idx)]) return;
    d.forEach(btn => {
      btn.classList.toggle(
        "gr-product-media__slide-btn--active",
        Number(idx) === Number(btn.dataset.idx)
      );
    });
  }

  /* ─── Cerrar zoom ─── */
  function L() {
    if (!n || !s) return;
    document.body.style.overflow = null;
    n.classList.add("gr-hidden");
    n.classList.remove("gr-product-media-magnify--loading");
    s.classList.add("gr-hidden");
  }

  /* ─── Init ─── */
  e = new Glide(".gr-product-media-main-slider", { type: "slider", gap: 0, perView: 1 });
  t = document.querySelector('.gr-product-media-main-slider [data-glide-el="track"]');
  r = Array.from(document.querySelectorAll(".js-product-media-slider-slide"));
  d = Array.from(document.querySelectorAll(".js-product-media-slide-btn"));
  o = document.querySelector(".js-product-media-slider-track");
  i = document.querySelector(".js-product-media-slider-prev");
  c = document.querySelector(".js-product-media-slider-next");
  n = document.querySelector(".js-product-media-magnify-popup");
  s = document.querySelector(".js-product-media-magnify-img");
  l = document.querySelector(".js-product-media-magnify-close-btn");
  a = document.querySelector(".js-product-media-magnify-backdrop");

  if (e) { e.on("run", u); e.mount(); }
  if (t) t.addEventListener("click", m);

  /* ─── Listeners en miniaturas ───────────────────────────────────────
     Usamos TANTO click (desktop) COMO touchend (móvil).
     touchend es necesario porque en móvil con overflow:hidden en el padre
     el evento click a veces no llega o llega tarde.
  ──────────────────────────────────────────────────────────────────── */
  d.forEach(function(btn) {
    /* Click — desktop y algunos móviles */
    btn.addEventListener("click", function(ev) {
      ev.preventDefault();
      activateThumb(btn.dataset.idx);
    });

    /* Touchend — móvil: más fiable que click con padres overflow:hidden */
    btn.addEventListener("touchend", function(ev) {
      ev.preventDefault(); /* evita el click sintético posterior */
      activateThumb(btn.dataset.idx);
    }, { passive: false });
  });

  if (i) i.addEventListener("click", p);
  if (c) c.addEventListener("click", f);
  if (l) l.addEventListener("click", L);
  if (a) a.addEventListener("click", L);

  /* ─── API pública ─── */
  window.mtnshop = window.mtnshop || {};
  window.mtnshop.productMedia = {
    primarySlider:   { glideInstance: e },
    secondarySlider: { scrollToSlide: h, highlightSlide: v }
  };
})();